
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/aisensy",
      function () {
        return require("private-next-pages/compare/aisensy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/aisensy"])
      });
    }
  